import gettext, { ngettext } from '@sdk/lang/gettext';
import { Persona } from '@sdk/personaCollection/types/Persona';

import { ACTIVITY_THRESHOLD } from './conversationTypingNotifier.consts';

export const filterOutInactiveUsers = (activeUsers: Map<number, number>) => {
  const now = Date.now();

  activeUsers.forEach((lastActivityTimestamp, userId) => {
    if (now - lastActivityTimestamp > ACTIVITY_THRESHOLD) {
      activeUsers.delete(userId);
    }
  });
};

export const createLabel = (activeUsers: Map<number, number>, personas: Persona[]) => {
  if (!activeUsers.size) return null;

  const userIds = activeUsers.keys();
  const firstUserId = userIds.next().value;
  const persona = personas.find((p) => p.id === firstUserId);
  const othersCount = activeUsers.size - 1;

  if (!othersCount) {
    return gettext('%(name)s is typing', {
      name: persona.name,
    });
  }

  const secondUserId = userIds.next().value;
  const secondPersona = personas.find((p) => p.id === secondUserId);

  return ngettext(
    '%(name)s and %(secondName)s are typing',
    '%(name)s and %(othersCount)s others are typing',
    othersCount,
    {
      name: persona.name,
      othersCount,
      secondName: secondPersona.name,
    }
  );
};
